import wixWindow from 'wix-window';
import { connect, connectPage, dispatch, getState } from 'public/storeon/index';
import { hasContent, buildVCard, getStaticUrl } from 'public/util';



/**
 * @param {string} value
 */
const changeValue = (value) => {
    dispatch('change/image', ['value', value]);
};

/**
 * @param {string} stateBox
 * @returns {() => void}
 */
const toggleState = (stateBox) => () => {
    dispatch('toggle/state', stateBox);
};

const changeSize = ({ target }) => {
    dispatch('change/image', [
        'width', parseInt(target.value, 10),
    ]);
};

const changeDark = ({ detail }) => {
    dispatch('change/image', [
        'dark', detail.slice(1),
    ]);
};

const changeLight = ({ detail }) => {
    dispatch('change/image', [
        'light', detail.slice(1),
    ]);
};

const changeText = () => {
    const value = $w('#textBoxText').value;

    if (hasContent(value)) {
        changeValue(value);
    }
};

const changeUrl = () => {
    const value = $w('#inputUrl').value;

    if (hasContent(value)) {
        const regexp = /^https?:\/\//i;
        const data = regexp.test(value) ? value : `https://${value}`;

        changeValue(data);
    }
};

const changePhone = () => {
    const value = $w('#inputPhone').value;

    if (hasContent(value)) {
        changeValue(`tel:${value}`);
    }
};

const changeSMS = () => {
    const phone = $w('#inputSMSPhone').value;
    const message = $w('#textBoxSMSText').value;

    if (hasContent(phone)) {
        changeValue(`SMSTO:${phone}:${message}`);
    }
};

const changeVCard = () => {
    const inputData = {
        name: $w('#inputVCardName').value,
        organisation: $w('#inputVCardOrganisation').value,
        email: $w('#inputVCardEmail').value,
        phone: $w('#inputVCardPhone').value,
        phoneMobile: $w('#inputVCardPhoneMobile').value,
        street: $w('#inputVCardStreet').value,
        city: $w('#inputVCardCity').value,
        zipcode: $w('#inputVCardZipcode').value,
        country: $w('#inputVCardCountry').value,
        url: $w('#inputVCardUrl').value
    }
    const vCardQRValue = buildVCard(inputData);
    if (hasContent(inputData.name) || hasContent(inputData.organisation)) {
        changeValue(vCardQRValue);
    }
};

const changeImage = async () => {
    try {
        if ($w("#uploadButtonImage").value.length == 0) {
            return;
        }
        dispatch('startUpload/image');
        const uploadedImage = await $w("#uploadButtonImage").startUpload();
        changeValue( getStaticUrl(uploadedImage.url) );
    } catch (err) {
        console.error(err.message);
    }
};

const changePDF = async () => {
    try {
         if ($w("#uploadButtonPDF").value.length == 0) {
            return;
        }
        dispatch('startUpload/pdf');
        const uploadedPDF = await $w("#uploadButtonPDF").startUpload();
        changeValue( getStaticUrl(uploadedPDF.url) );
    } catch (err) {
        console.error(err.message);
    }
};

const changeLocation = () => { //TODO
    const location = $w('#addressInput').value ? $w('#addressInput').value.location : false;
    if (location) {
        $w('#googleMaps').location = location;
        changeValue(`geo:${location.latitude},${location.longitude}`);
    }
};

const changeWifi = () => {
    const ssid = $w('#inputSSIDWIFI').value;
    const encryption = $w('#dropdownAuthWIFI').value;
    const password = $w('#inputPasswordWIFI').value;
    if (hasContent(ssid)) {
        changeValue(`WIFI:S:${ssid};T:${encryption};P:${password};;`);
    }
};

const changeEmail = () => {
    const email = $w('#inputEmail').value;
    const emailSubject = $w('#inputEmailSubject').value ? $w('#inputEmailSubject').value : '';
    const emailBody = $w('#textBoxEmailBody').value ? $w('#textBoxEmailBody').value : '';
    if (hasContent(email)) {
        changeValue(`mailto:${email}?subject=${emailSubject}&body=${emailBody}`);
    }
};

const openLightboxes = () => {
    dispatch('open/lightbox');
    wixWindow.openLightbox('Download', getState());
};

connectPage(() => {
    // $w('#buttonCreateWebsite').link = 'https://users.wix.com/signin?view=sign-up&sendEmail=true&postSignUp=https:%2F%2Fwww.wix.com%2Fnew%2Fintro&loginCompName=Signup_H&referralInfo=Signup_H&postLogin=https:%2F%2Fwww.wix.com%2Fmy-account%2Fsites&overrideLocale=en&forceRender=true';
    // $w('#buttonCreateWebsite').target = '_self';
    // $w('#buttonCreateWebsite').onClick(() => {dispatch('click/createWebsite')})
    // Toggle state Box
    $w('#buttonQRText').onClick(toggleState('text'));
    $w('#buttonQRUrl').onClick(toggleState('url'));
    $w('#buttonQRPhone').onClick(toggleState('phone'));
    $w('#buttonQRWIFI').onClick(toggleState('wifi'));
    $w('#buttonQRSMS').onClick(toggleState('sms'));
    $w('#buttonQRVCard').onClick(toggleState('vCard'));
    $w('#buttonQREmail').onClick(toggleState('email'));
    $w('#buttonQRImage').onClick(toggleState('image'));
    $w('#buttonQRPDF').onClick(toggleState('pdf'));
    $w('#buttonQRLocation').onClick(toggleState('location'));
    // Size
    $w('#inputSize').onInput(changeSize);
    $w('#sliderSize').onChange(changeSize);
    // Color
    $w('#CEPickerDots').on('change', changeDark);
    $w('#CEPickerBackground').on('change', changeLight);
    // Open lightbox
    $w('#buttonDownload, #boxImage').onClick(openLightboxes);
    // Text QR
    $w('#textBoxText').onInput(changeText);
    // URL QR
    $w('#inputUrl').onInput(changeUrl);
    // Phone QR
    $w('#inputPhone').onInput(changePhone);
    // SMS QR
    $w('#inputSMSPhone, #textBoxSMSText').onInput(changeSMS);
    // VCard QR
    $w('#inputVCardName, #inputVCardOrganisation, #inputVCardEmail, #inputVCardPhone, #inputVCardPhoneMobile, #inputVCardStreet, #inputVCardCity, #inputVCardZipcode, #inputVCardCountry, #inputVCardUrl').onInput(changeVCard);
    // Image QR
    $w('#uploadButtonImage').onChange(changeImage);
    // PDF QR
    $w('#uploadButtonPDF').onChange(changePDF);
    // Location QR
    $w('#addressInput').onChange(changeLocation);
    // Wifi QR
    $w('#inputSSIDWIFI, #inputPasswordWIFI').onInput(changeWifi);
    $w('#dropdownAuthWIFI').onChange(changeWifi);
    // Email QR
    $w('#inputEmail, #inputEmailSubject, #textBoxEmailBody').onInput(changeEmail);
});

connect('width', ({ width }) => {
    $w('#inputSize, #sliderSize').value = width;
});

connect('url', ({ url }) => {
    $w('#imageQr').src = url;
});

connect('stateBox', ({ stateBox }) => {
    $w('#statebox').changeState(stateBox);

    switch (stateBox) {
    case 'text':
        return changeText();
    case 'url':
        return changeUrl();
    case 'phone':
        return changePhone();
    case 'sms':
        return changeSMS();
    case 'vCard':
        return changeVCard();
    case 'image':
        return changeImage();
    case 'pdf':
        return changePDF();
    case 'location':
        return changeLocation();
    case 'wifi':
        return changeWifi();
    case 'email':
        return changeEmail();
    }
});